<template>
  <wo-region>
    <po-loading v-show="loading" mod-layover />
    <po-table v-if="hasTypes" mod-selectable mod-no-v-borders mod-no-h-borders>
      <template slot="body">
        <tr v-for="type in types" :key="type.id" @click="emitSelect(type)">
          <td class="po-table__cell--media"><img v-if="type.image_url" :src="type.image_url" /></td>
          <td>{{ type.name }}</td>
        </tr>
      </template>
    </po-table>
    <po-empty-state v-else-if="types" labelKey="reco.noResults" v-wo-align:center />
    <po-empty-state v-else labelKey="reco.noSearch" v-wo-align:center />
  </wo-region>
</template>
<script>

import _ from 'lodash'

export default {
  props: {
    value: Object
  },
  computed: {
    types () {
      return this.value && this.value.items
    },
    hasTypes () {
      return !_.isEmpty(this.types)
    },
    loading () {
      return this.value && this.value.updating
    }
  },
  methods: {
    emitSelect (type) {
      this.$emit('select', type)
    }
  }
}
</script>
